import { Error, FieldWrap } from "components/styled/Field";
import React from "react";
import styled from "styled-components";
import { borderDefault } from "utils/constants/colors";

const StyledFieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  border: 1px solid ${borderDefault};
  border-radius: 4px;
  padding: 0 8px;

  > legend {
    padding: 0 8px;
    width: auto;
    font-size: 14px;
    line-height: 1.5;
  }
`;

export function Fieldset({ children, label, error }) {
  return (
    <StyledFieldset>
      <legend>{label}</legend>
      {children}
      {error ? <Error>{error.result}</Error> : null}
    </StyledFieldset>
  );
}
